// Access to the generated form definition.
import formsJson from "../generated/forms.json";
import type { FormsDef, FormDef, FieldDef, ToolDef } from "./model.ts";

export const FORMS: FormsDef = formsJson as unknown as FormsDef;

const byKey = new Map<string, FormDef>(FORMS.forms.map((f) => [f.key, f]));
const byNumber = new Map<string, FormDef>(FORMS.forms.map((f) => [f.number, f]));
const toolByName = new Map<string, ToolDef>(FORMS.tools.map((t) => [t.name.toLowerCase(), t]));

export function formByKey(key: string): FormDef | undefined {
  return byKey.get(key);
}

export function formByNumber(num: string): FormDef | undefined {
  return byNumber.get(num);
}

export function fieldsOf(form: FormDef): FieldDef[] {
  return form.sections.flatMap((s) => s.fields);
}

export function fieldByRef(ref: string): FieldDef | undefined {
  const key = ref.split(".")[0];
  return byKey.get(key)?.sections.flatMap((s) => s.fields).find((f) => f.ref === ref);
}

/** "office" when the instrument is in the office, "buy" when it must be bought or hired, null when unknown. */
export function toolStatus(name: string | null): "office" | "buy" | null {
  if (!name) return null;
  const t = toolByName.get(name.toLowerCase());
  if (!t) return null;
  return t.section === "buy" ? "buy" : "office";
}

export function toolInfo(name: string | null): ToolDef | undefined {
  return name ? toolByName.get(name.toLowerCase()) : undefined;
}

/** The index groups from 00 Start Here, with each entry resolved to its form (logs and reference sheets have none). */
export function indexGroups(): { title: string; entries: { number: string; name: string; what: string; toolsMissing: string; form: FormDef | undefined }[] }[] {
  return FORMS.help.index.map((g) => ({
    title: g.title,
    entries: g.entries.map((e) => ({ number: e.number, name: e.name, what: e.what, toolsMissing: e.toolsMissing, form: byNumber.get(e.number) })),
  }));
}
